import { render, staticRenderFns } from "./CustomerAuthPage.vue?vue&type=template&id=bc40a268&"
import script from "./CustomerAuthPage.vue?vue&type=script&lang=js&"
export * from "./CustomerAuthPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports